// libraries.
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";

// hooks.
import { useGetInventoryPropertyInfo } from "@store/apiSlices/inventoryPropertyInfo/inventoryPropertyInfo.hook";
import { useGetLeadDetailInfo } from "@store/apiSlices/leadDetail/leadDetail.hooks";
import { useApplyRangeToPublicationPrice } from "@pages/InventoryPage/modules/InventorySummary/components/shared/hooks/applyRangeToPublicationPrice";

// components.
import { MinPriceFooter } from "@pages/InventoryPage/modules/InventorySummary/components/shared/MinPriceFooter";
import {
  getSelectedOption,
  getSuggestionOption,
} from "@domains/VIM/slices/vim.slice";
import {
  calculatePercentageInPrice,
  percentageToApplyInRelatedPricesMX,
} from "@shared/DashboardComponentsSummary/components/utils";

export const MinPublicationPriceMX = () => {
  const {
    register,
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const minPublicationPriceInput = watch("minPublicationPrice");
  const pubPriceMX = watch("publicationPrice");
  const leader = watch("leader");

  const { applyRangeToPublicationPrice } = useApplyRangeToPublicationPrice();

  const { area } = useGetLeadDetailInfo();

  const isEditing = useRef(false);
  const selectedOptionMX = useSelector(getSelectedOption);
  const suggestionOptionMX = useSelector(getSuggestionOption);

  const { minPublicationPrice: defaultMinPublicationPrice } =
    useGetInventoryPropertyInfo();

  const minPublicationPriceM2 =
    Number(minPublicationPriceInput ?? defaultMinPublicationPrice) / area;

  const isDisabled = Boolean(selectedOptionMX || suggestionOptionMX);

  useEffect(() => {
    setValue("minPublicationPrice", defaultMinPublicationPrice);
  }, [defaultMinPublicationPrice]);

  useEffect(() => {
    if (pubPriceMX && !isEditing.current) {
      const priceMin = calculatePercentageInPrice(
        pubPriceMX,
        false,
        percentageToApplyInRelatedPricesMX,
      );
      setValue("minPublicationPrice", priceMin, {
        shouldDirty: true,
      });
    }
    isEditing.current = false;
  }, [pubPriceMX, setValue]);

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <div>Precio mínimo publicado</div>
        <input
          data-testid="minPublicationPriceInputMX"
          disabled={isDisabled}
          {...register("minPublicationPrice", {
            validate: (value) =>
              applyRangeToPublicationPrice({
                defaultPrice: defaultMinPublicationPrice,
                leader,
                price: value,
              }),
            valueAsNumber: true,
          })}
          type="text"
          className="rounded-3 p-2"
        />
      </div>
      <MinPriceFooter pricePerM2={minPublicationPriceM2} errors={errors} />
    </>
  );
};
